import {borlabs} from "./cmps/borlabs.mjs"
import {complianz} from "./cmps/complianz.mjs"
import {cookieCompliance} from "./cmps/cookie-compliance.mjs"
import {cookieScript} from "./cmps/cookie-script.mjs"
import {cookiebot} from "./cmps/cookiebot.mjs"
import {cookiefirst} from "./cmps/cookiefirst.mjs"
import {cookieyes} from "./cmps/cookieyes.mjs"
import {iubenda} from "./cmps/iubenda.mjs"
import {mooveCookieCompliance} from "./cmps/moove-cookie-compliance.mjs"
import {onetrust} from "./cmps/onetrust.mjs"
import {realCookieBanner} from "./cmps/real-cookie-banner.mjs"
import {termly} from "./cmps/termly.mjs"
import {usercentrics} from "./cmps/usercentrics.mjs"
import {wpAutoTerms} from "./cmps/wp-auto-terms.mjs"
import {wpConsentApi} from "./cmps/wp-consent-api.mjs"
import {wpCookieConsent} from "./cmps/wp-cookie-consent.mjs"

export default [
	borlabs,
	complianz,
	cookieCompliance,
	cookieScript,
	cookiebot,
	cookiefirst,
	cookieyes,
	iubenda,
	mooveCookieCompliance,
	onetrust,
	realCookieBanner,
	termly,
	usercentrics,
	wpAutoTerms,
	wpConsentApi,
	wpCookieConsent,
]
